import styled from "styled-components";

import { ErrorNotificationStyledProps as Props } from "./ErrorNotification.types";
import Notification from "components/global/notifications/Notification/Notification";

const ErrorNotificationStyled = styled(Notification)<Props>`
  display: grid;
  grid-template-columns: 3.2rem auto;
  padding: 1.2rem;
  column-gap: 1.6rem;
  align-items: center;
  border: 0.1rem solid var(--palette-red-s60-l60);
  cursor: ${props => (props.clickable ? "pointer" : "auto")};

  .ErrorNotification {
    &__title {
      font-family: inherit;
      color: var(--palette-red-s60-l60);
      font-weight: 600;
      line-height: 2rem;
      font-size: 1.6rem;
    }

    &__message {
      font-family: inherit;
      font-size: 1.4rem;
      color: var(--palette-black);
      line-height: 2rem;
      grid-column: 2/3;
    }
  }
`;

export default ErrorNotificationStyled;
